import { useEffect } from "react";
import { Link } from "react-router-dom";
import { OFFER } from "../config/offer.config";
import { trackViewContent } from "../lib/pixel";

/**
 * Landing long-form story (tráfico frío): hero → dolor → visión → prueba social →
 * cómo funciona → un solo CTA al estimador. Copy 100% on-brand.
 */
export default function LandingLongForm() {
  useEffect(() => trackViewContent("landing_story"), []);
  return (
    <main className="mx-auto max-w-2xl px-6 py-16">
      <p className="font-sans text-xs uppercase tracking-[0.2em] text-clay">
        A Couple &amp; A Dream · {OFFER.serviceArea.join(", ")}
      </p>

      <h1 className="mt-4 font-serif text-5xl leading-tight text-ink">
        The bathroom your home deserves — designed and built under one roof.
      </h1>

      <p className="mt-6 text-lg text-stone">
        Your bathroom doesn’t have to stay the room you avoid showing. As a studio,
        we design and build every transformation ourselves — one team, start to
        finish, no handoffs.
      </p>

      <Section title="From dated to the favorite room in the house">
        A great transformation starts with design, not demolition. We plan the whole
        space around how you actually live — light, storage, materials — then build it
        with the same hands that drew it.
      </Section>

      <Section title="A studio approach, across Tampa Bay">
        Families across {OFFER.serviceArea.join(", ")} are already transforming their
        bathrooms with us. Every project is an investment in your home’s value and
        your everyday.
      </Section>

      <Section title="How it works">
        Build your bathroom in our interactive tool, unlock your tentative investment
        range, and a designer calls you to walk through the vision — all within a day.
      </Section>

      <div className="mt-12 rounded-xl border border-stone/20 bg-white/50 p-8 text-center">
        <p className="font-serif text-2xl text-ink">See what yours could look like.</p>
        <Link
          to="/estimator"
          className="mt-5 inline-block rounded-md bg-ink px-8 py-3 font-sans text-sm uppercase tracking-widest text-bone transition hover:bg-clay"
        >
          Design your transformation →
        </Link>
      </div>
    </main>
  );
}

function Section({ title, children }: { title: string; children: React.ReactNode }) {
  return (
    <section className="mt-10">
      <h2 className="font-serif text-2xl text-ink">{title}</h2>
      <p className="mt-3 text-stone">{children}</p>
    </section>
  );
}
